import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqUnblockUser');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'chat',
  type: 'delete',
  slug: ['blocked_users', { type: 'payload', selector: ['userId'] }],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqUnblockUser.js